var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"step-counter"},[_c('span',{class:{'change-color':_vm.isActive, 'change-size':_vm.isSmaller}},[_vm._v(_vm._s(_vm.ovalNum))])])}
var staticRenderFns = []
export { render, staticRenderFns }